module.exports = __webpack_public_path__ + "img/hollow-red-circle.cb1ecb5d.png";